import {BoardContainer, TitleContainer,} from "../../assets/GlobalStyles";
import {useParams} from "react-router-dom";
import ScrollToTop from "../../components/common/ScrollToTop";
import CreateReports from "./CreateReports";
import CustomReports from "./CustomReports";
import ReportsPeriod from "./ReportsPeriod";
import ReportsAdver from "./ReportsAdver";
import ReportsCampaign from "./ReportsCampaign";
import ReportsPeriodHour from "./ReportsPeriodHour";
import UnifiedManagementShell from "../../components/common/UnifiedManagementShell";

export default function Reports(){
  const params = useParams()
  return(
    <main>
      <ScrollToTop/>
      <BoardContainer>
        <TitleContainer>
          <h1>보고서</h1>
        </TitleContainer>
        {/* 기간별보고서 */}
        <UnifiedManagementShell>
        {params.id === 'reportsPeriod' && <ReportsPeriod/>}
        {params.id === 'reportsPeriodHour' && <ReportsPeriodHour/>}
        {/* 광고주별보고서 */}
        {params.id === 'reportsAdver' && <ReportsAdver/>}
        {/* 캠페인별보고서 */}
        {params.id === 'reportsCampaign' && <ReportsCampaign/>}
        {params.id === 'reports' && <CreateReports/>}
        {params.id === 'customReports' && <CustomReports/>}
        </UnifiedManagementShell>
      </BoardContainer>
    </main>
  )
}

